import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { contractDraftsQueryKey } from '@services/contracts/drafts'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

type SendFlatDraftBody = {
  flat_id: string
  payment_time: string
  deposit_paid?: boolean
}

// Rovnako ako pri nájomcovi: backend vráti, komu návrh odišiel a komu nie.
type SendDraftResult = {
  sent: string[]
  failed: string[]
}

export function useSendFlatContractDraft() {
  const toast = useToast()
  const { t } = useTranslation('flat')
  const onError = useOnError()
  const queryClient = useQueryClient()

  async function sendDraft(body: SendFlatDraftBody) {
    const res = await apiClient.post<SendDraftResult>(
      `${SNA_PREFIX}contracts/flats/send-draft`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: sendDraft,
    onSuccess: (data) => {
      if (data.failed?.length) {
        toast.error({
          message: t('contract.draft_partially_sent', {
            emails: data.failed.join(', ')
          })
        })
        return
      }
      toast.success({
        message: t('contract.draft_sent', { total: data.sent.length })
      })
    },
    onError,
    // A failed attempt is recorded too, so refresh either way.
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: contractDraftsQueryKey })
  })
}
